// 2023/12/27 Leading Win 教育機能対応 DXWEBEDU00100_教育実施状況確認 start
import styled from 'styled-components';

export const EducationStatusStyled = styled.div`
  .body {
    height: 100%;
    border-radius: 8px;
    background-color: #ffffff;
    box-shadow: var(--box-shadow);
    padding-bottom: 15px;
    position: relative;
  }
  .appPopuSty {
    font-size: 25px;
    font-weight: 650;
  }
  .colunmSty {
    text-align: left;
    margin-left: 5px;
  }
  .ant-pagination-item-active {
    background: #3c82c0;
  }
  .ant-pagination-item-active a {
    color: #ffffff !important;
  }
  .txtSet {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    max-width: 100%;
  }
  .title {
    font-size: 20px;
    letter-spacing: 0;
    line-height: 30px;
    font-weight: 600;
    margin-top: 5px;
    margin-bottom: 5px;
    margin-left: 30px;
  }
  .ant-form-item-no-colon {
    margin-top: 5px !important;
  }
  .searchInfo {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    border-bottom: 1px solid rgba(0, 0, 0, 0.05);
    .titleInfo {
      font-size: 15px;
      letter-spacing: 0;
      font-weight: 600;
      margin-bottom: 20px;
    }
    .full-width {
      font-size: 15px;
      display: flex;
      justify-content: flex-start;
      width: 100%;
      font-weight: 600;
      height: 40px;
      align-items: center;
      .ant-form-item {
        margin-bottom: 0px !important;
      }
      .gyosyaCodeStyle {
        font-size: 15px !important;
        display: flex;
        flex-direction: row;
        margin-right: 10px;
        .inputGyosya {
          margin-left: 40px;
        }
      }

      .gyosyaSitenCodeStyle {
        display: flex;
        flex-direction: row !important;
        margin-right: 10px;
        .inputGyosyaSiten {
          margin-left: 10px;
        }
      }
      .gyosyaNameStyle {
        font-size: 15px !important;
        display: flex;
        flex-direction: row !important;
        margin-left: 75px;
        margin-right: 10px;
        .inputGyosyaname {
          margin-left: 40px;
        }
      }
      .workerNameStyle {
        font-size: 15px !important;
        display: flex;
        flex-direction: row !important;
        margin-left: 60px;
        margin-right: 10px;
        .inputworkername {
          margin-left: 40px;
        }
      }
      .jyuchuCodeStyle {
        font-size: 15px !important;
        display: flex;
        flex-direction: row !important;
        margin-right: 10px;
        .inputJyuChu {
          margin-left: 40px;
        }
      }
      .tsuikacodeCodeStyle {
        display: flex;
        flex-direction: row !important;
        margin-right: 10px;
        .inputTsuika {
          margin-left: 10px;
        }
      }
      .siteNameStyle {
        font-size: 15px !important;
        display: flex;
        flex-direction: row !important;
        margin-left: 75px;
        margin-right: 10px;
        .inputSitename {
          margin-left: 40px;
        }
      }
      .subButSty {
        .ktAZZG {
          height: 34px;
        }
      }
    }
    .checkBoxStyle {
      margin-left: 10px;
      margin-right: 10px;
    }
    .midTitle {
      margin-left: 40px;
    }
  }
  .tableSty {
    margin-left: 45px;
    width: 94%;
    .boder-center {
      text-align: center;
    }
    .pagination {
      padding-top: 24px;
      padding-bottom: 5px;
      text-align: center;
    }
    .aStyle {
      text-decoration: underline;
    }
    .allCheckBox {
      font-size: 15px !important;
    }
    .buttonSty {
      display: flex;
      justify-content: space-between;
      .leftButton {
        margin-top: 23px;
        background: #3c82c0;
        color: #ffffff !important;
      }
      .leftButtontrue {
        margin-top: 23px;
      }
      .rightButton {
        display: flex;
        flex-direction: column;
        text-align: center;
      }
    }
  }
  .newOrSendBtn {
    background: #3c82c0;
    color: #ffffff !important;
  }
  .ant-checkbox-disabled {
    .ant-checkbox-inner {
      background: #b3b3b3;
    }
  }
  .form-group {
    display: flex;
    align-items: center;
    .ant-form-item {
      margin-bottom: 0px !important;
    }
  }
  .form-col-1 {
    padding: 5px 5px 5px 5px;
    width: 8%;
  }
  .form-col-2 {
    padding: 5px 5px 5px 5px;
    width: 10%;
  }
  .form-col-3 {
    display: flex;
    justify-content: center;
    padding: 5px 5px 5px 5px;
    width: 2%;
  }
  .form-col-4 {
    padding: 5px 5px 5px 5px;
    width: 4%;
  }
  .form-col-5 {
    padding: 5px 5px 5px 5px;
    width: 6%;
  }
  .form-col-6 {
    padding: 5px 5px 5px 5px;
    width: 22%;
  }
  .form-col-7 {
    padding: 5px 5px 5px 5px;
    width: 7%;
  }
  .form-col-8 {
    padding: 5px 5px 5px 5px;
    width: 12%;
  }
  .form-col-9 {
    display: flex;
    justify-content: right;
    padding: 5px 5px 5px 5px;
    width: 43%;
  }
  .form-col-blank {
    padding: 5px 5px 5px 5px;
    width: 4%;
  }
  .form {
    font-size: 15px;
    font-weight: 600;
    margin-left: 45px;
    width: 94%;
  }
`;
// 2023/12/27 Leading Win 教育機能対応 DXWEBEDU00100_教育実施状況確認 end
